import {
  Component,
  ElementRef,
  NgZone,
  OnInit,
  Renderer2,
  ViewChild,
} from '@angular/core';
import { GoogleMap } from '@angular/google-maps';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { PermissionsEnum } from 'src/app/models/role.model';
import {
  SiteVerificationConnectionPossible,
  SiteVerificationDetails,
  SiteVerificationNeedForPole,
  SiteVerificationRemark,
  SiteVerificationTypeOfCable,
  getInitDetails,
  getInitAddress,
} from 'src/app/models/siteVerification.model';
import { User } from 'src/app/models/user.model';
import { AuthService, CimSubstationService, GeographicalRegionService, PermissionsService, SubGeographicalRegionService } from 'shared-lib';
import { SiteVerificationService } from 'src/app/services/siteVerification.service';
import { TranslationService } from 'src/app/services/translation.service';
import { UserService } from 'src/app/services/user.service';
import { PersonalDataStateService } from 'src/app/_modules/customers/components/personal-data/services/personal-data-state.service';
import { AreaService } from 'src/app/services/area.service';
import { RegionService } from 'src/app/services/region.service';
import { DtService } from 'src/app/services/dt.service';
import { DtDto, DtSiteVerification, DTTypeOfConnection } from 'src/app/models/dt.model';
import { Feeder11Service } from 'src/app/services/feeder11.service';
import { Feeder33Service } from 'src/app/services/feeder33.service';
import { BlobStorageService } from 'src/app/_modules/shared/_services/blob-storage.service';
import { ContainerNames } from 'src/app/models/containerNames.model';
import { CustomerService } from 'src/app/services/customer.service';
import { MeterService } from 'src/app/services/meter.service';
import { TariffService } from 'src/app/services/tariff.service';
import { OptionObj } from 'src/app/models/util.model';
import { Neighborhood, ClientType, TypeOfConnection } from 'src/app/models/customer.model';
import { TranslateService } from '@ngx-translate/core';
import { ImageType } from 'src/app/models/image.model';
import { forkJoin } from 'rxjs';
import { MapConfiguration } from 'src/app/models/utility.model';

@Component({
  selector: 'app-site-verification-details',
  templateUrl: './site-verification-details.component.html',
  styleUrls: ['./site-verification-details.component.scss'],
})
export class SiteVerificationDetailsComponent implements OnInit {
  @ViewChild('closeModal') closeModal: ElementRef;
  @ViewChild(GoogleMap) svGeoMap?: GoogleMap;

  constructor(
    private activatedRoute: ActivatedRoute,
    private siteVerificationService: SiteVerificationService,
    private toastr: ToastrService,
    public permissionsService: PermissionsService,
    private translationService: TranslationService,
    private renderer: Renderer2,
    private userService: UserService,
    private stateService: PersonalDataStateService,
    private areaService: AreaService,
    private regionService: RegionService,
    private dtService: DtService,
    private feeder11Service: Feeder11Service,
    private feeder33Service: Feeder33Service,
    private blobStorageService: BlobStorageService,
    private customerService: CustomerService,
    private meterService: MeterService,
    private tariffService: TariffService,
    private ngZone: NgZone,
    private translateService: TranslateService,
    private router: Router,
    public authService: AuthService,
    private geographicalRegionService: GeographicalRegionService,
    private subGeographicalRegionService: SubGeographicalRegionService,
    private cimSubstationService: CimSubstationService,
  ) { }
  selectedImage: string = '';
  filterText: string = '';
  filteredMobileUsers: User[] = [];
  tempAssignedUserId: number = 0;
  PermissionsEnum = PermissionsEnum;
  editEnabled: boolean = false;
  onlyView: boolean = false;
  buName: string = this.translationService.getByKeyFromStorage('BU');
  utName: string = this.translationService.getByKeyFromStorage('UT');
  siteVerification: SiteVerificationDetails = getInitDetails();
  private pendingImages: { imageType: string; slotIndex: number; url: string; file: File; existsAtSlot: boolean }[] = [];
  imgElement: any;
  isDropdownOpened: boolean = false;
  placeholderImage: string = '../../../../assets/no-image.png';
  imgZoomFullContainer: any;
  currentRotation: number = 0;
  assignedUserId: number = 0;
  mobileUsers: User[] = [];
  id: string = '';
  rejectionNote: string = '';
  suspensionNote: string = '';
  showApprove: boolean = false;
  showReject: boolean = false;
  showSuspend: boolean = false;
  showRecallMenu: boolean = false;
  dtName: string = this.translationService.getByKeyFromStorage('DTNumber');
  customerId: number = 0;
  totalLoad?: number = 0;
  isGeolocationMapVisible: boolean = false;
  selectedMapLatitude: number | null = null;
  selectedMapLongitude: number | null = null;
  clientType: string = '';
  customerType: string = '';
  svEditEnabled: boolean = false;
  regions: any[] = [];
  areas: any[] = [];
  svRegionId: number = 0;
  svAreaId: number = 0;
  svCardDtResults: any[] = [];
  svSvDtResults: any[] = [];
  svFeeders: any[] = [];
  svFeeders33: any[] = [];
  svCardDtFilter: string = '';
  svSvDtFilter: string = '';
  svCardDtDropdownOpen: boolean = false;
  svSvDtDropdownOpen: boolean = false;
  svCardSubstationResults: any[] = [];
  svSvSubstationResults: any[] = [];
  svCardSubstationFilter: string = '';
  svSvSubstationFilter: string = '';
  svCardSubstationDropdownOpen: boolean = false;
  svSvSubstationDropdownOpen: boolean = false;
  Neighborhood = Neighborhood;
  ClientType = ClientType;
  TypeOfConnection = TypeOfConnection;
  SiteVerificationRemark = SiteVerificationRemark;
  svNeighborhoodOptions: OptionObj[] = [];
  svSltOptions: OptionObj[] = [];
  svClientTypeOptions: OptionObj[] = [];
  svMeterTypeOptions: OptionObj[] = [];
  svTypeOfConnectionOptions: OptionObj[] = [];
  svTypeOfConnections: OptionObj[] = [];
  svTypesOfCable: OptionObj[] = [];
  svConnectionPossibleoptions: OptionObj[] = [];
  svNeedForPoleOptions: OptionObj[] = [];
  svRemarks: any[] = [];
  svTariffs: any[] = [];
  svTariffResults: any[] = [];
  svTariffFilter: string = '';
  svTariffDropdownOpen: boolean = false;
  svPendingLatitude: number = 5.74644;
  svPendingLongitude: number = 0.007479;
  svHasSavedGeoLocation: boolean = false;
  svIsMapEditMode: boolean = false;
  private svOriginalLatitude: number | null = null;
  private svOriginalLongitude: number | null = null;
  private svSearchInputEl: HTMLInputElement | null = null;
  private svFullscreenHandler?: () => void;
  private svPacObserver?: MutationObserver;
  private svBodyPacObserver?: MutationObserver;
  utilityId: number = 0;
  svPendingAddress: string = '';
  svMapSearchValue: string = '';

  get svGeoModalTitle(): string {
    return this.svPendingAddress || this.svMapSearchValue || 'Geolocation';
  }
  svMapCenter: google.maps.LatLngLiteral = { lat: 5.74644, lng: 0.007479 };
  svMarkerPosition: google.maps.LatLngLiteral = { lat: 5.74644, lng: 0.007479 };
  svMapZoom: number = 15;
  svGeoModalVisible: boolean = false;
  svMarkerOptions: google.maps.MarkerOptions = { draggable: false };
  private svMarkerBlinkIntervalId?: number;
  private svShouldBlinkMarkerWhenMapReady: boolean = false;
  private svPlacesAutocomplete?: google.maps.places.Autocomplete;
  svMapOptions: google.maps.MapOptions = {
    mapTypeId: 'hybrid',
    streetViewControl: false,
    fullscreenControl: true,
    mapTypeControl: true,
  };
  areLocationImagesVisible: boolean = true;
  //CIM
  geoRegions: any[] = [];
  subGeoRegions: any[] = [];
  selectableSubGeoRegions: any[] = [];
  substations: any[] = [];
  filteredSubstations: any[] = [];
  svGeographicalRegionId: number = 0;
  ngOnInit(): void {
    const verificationId = this.activatedRoute.snapshot.paramMap.get('detailsId');
    this.id = verificationId || '';
    let utilityId = parseInt(
      this.activatedRoute.snapshot.paramMap.get('utilityId') || ''
    );
    this.utilityId = utilityId;
    this.getSiteVerification(verificationId);
    this.setFieldsVisibility();
  }

  setClientAndCustomerType() {
    this.clientType = this.stateService.setClientType(this.siteVerification.accountKyc.clientType) ?? '';
    this.customerType = this.stateService.setCustomerType(this.siteVerification.accountKyc.customerType) ?? '';
  }

  getMobileUsers() {
    this.userService
      .getMobileUsers(this.siteVerification.area.id, this.filterText)
      .subscribe({
        next: (response) => {
          const responseData = response.body;
          if (responseData?.status === 200 || responseData?.status === 'OK') {
            this.mobileUsers = responseData.data;
            if (this.mobileUsers.length == 0) {
              this.isDropdownOpened = false;
            } else {
              this.isDropdownOpened = true;
            }
          } else {
            this.toastr.error(responseData?.message);
          }
        },
        error: (_) => {
          this.toastr.error('Error occured');
        },
      });
  }
  filterMobileUsers() {
    this.isDropdownOpened = true;
    this.tempAssignedUserId = 0;
    this.getMobileUsers();
  }
  edit() {
    const kyc = this.siteVerification?.accountKyc;
    if (kyc) {
      kyc.employerAddress ??= getInitAddress();
      kyc.addressOfLandlord ??= getInitAddress();
    }



    if (this.authService.hasCimDataIntegration) {
      this.getGeoRegions();
      this.getSubGeoRegions();
      this.getSubstations();
    } else {
      this.svRegionId = this.siteVerification.area?.regionId ?? 0;
      this.svAreaId = this.siteVerification.accountKyc?.addressOfLandlord?.areaId ?? 0;
      this.loadRegions();
      if (this.siteVerification.area?.regionId) {
        this.loadAreasByRegion(this.siteVerification.area.regionId);
      }
    }
    this.editEnabled = true;
  }
  getGeoRegions() {
    this.geographicalRegionService.getAllForSelect(this.utilityId).subscribe({
      next: (response) => {
        const responseData = response.body;
        if (responseData?.status === 200 || responseData?.status === 'OK') {
          this.geoRegions = responseData.data ?? [];
        } else {
          this.toastr.error(responseData?.message);
        }

      },
      error: () => {
        this.toastr.error('Error occured');

      },
    });
  }

  getSubGeoRegions() {
    this.subGeographicalRegionService.getAllForMappings().subscribe({
      next: (response) => {
        const responseData = response.body;
        if (responseData?.status === 200 || responseData?.status === 'OK') {
          this.subGeoRegions = responseData.data ?? [];
          this.selectableSubGeoRegions = this.subGeoRegions;
          this.syncCimRegionSelection();
        } else {
          this.toastr.error(responseData?.message);
        }

      },
      error: () => {
        this.toastr.error('Error occured');

      },
    });
  }
  getSubstations() {
    this.cimSubstationService
      .getAllSubstationsCached({ voltageClasses: ['LV'] })
      .subscribe({
        next: (response) => {
          const responseData = response.body;
          if (responseData?.status === 200 || responseData?.status === 'OK') {
            this.substations = responseData.data ?? [];
            this.filteredSubstations = this.substations

          } else {
            this.toastr.error(responseData?.message);
          }
        },
        error: () => this.toastr.error('Error occured'),
      });
  }

  openEditModal() { }
  openGeolocationMap(latitude?: number | null, longitude?: number | null) {
    if (latitude == null || longitude == null) {
      return;
    }

    this.selectedMapLatitude = latitude;
    this.selectedMapLongitude = longitude;
  }

  onGeolocationMapModalOpen() {
    this.isGeolocationMapVisible = true;
  }

  onGeolocationMapModalFade() {
    this.isGeolocationMapVisible = false;
    this.selectedMapLatitude = null;
    this.selectedMapLongitude = null;
  }

  rotateRight() {
    this.currentRotation += 90;
  }
  rotateLeft() {
    this.currentRotation -= 90;
  }
  showImage(num: number) {
    if (num === 0) {
      this.selectedImage = this.getFrontViewImage(0) || '';
    } else if (num === 1) {
      this.selectedImage = this.getFrontViewImage(1) || '';
    } else if (num === 2) {
      this.selectedImage = this.getFrontViewImage(2) || '';
    } else if (num === 3) {
      this.selectedImage = this.getBuildingMountedImage() || '';
    } else if (num === 4) {
      this.selectedImage = this.getCardImage() || '';
    } else if (num === 5) {
      this.selectedImage =
        this.siteVerification.accountKyc.customersSignitureUrl;
    } else if (num === 6) {
      this.selectedImage =
        this.siteVerification.accountKyc.landlordsSignitureUrl;
    } else if (num === 7) {
      this.selectedImage =
        this.siteVerification.accountKyc.electricalContractorsSignitureUrl;
    } else if (num === 8) {
      this.selectedImage =
        this.siteVerification.accountKyc.applicantsSignitureUrl;
    } else if (num === 9) {
      this.selectedImage = this.siteVerification.accountKyc.passportUrl;
    } else if (num === 10) {
      this.selectedImage = this.getCutOutImage() || '';
    } else if (num === 11) {
      this.selectedImage = this.getUtilitySupplyImage() || '';
    }
  }
  getBuildingMountedImage() {
    var image = this.siteVerification.images?.find(
      (x) => x.imageType === 'MountedTag'
    )?.url;

    return image;
  }
  getCardImage() {
    var image = this.siteVerification.images?.find(
      (x) => x.imageType === 'Card'
    )?.url;

    return image;
  }
  getUtilitySupplyImage() {
    var image = this.siteVerification.images?.find(
      (x) => x.imageType === 'UtilitySupply'
    )?.url;

    return image;
  }
  getCutOutImage() {
    var image = this.siteVerification.images?.find(
      (x) => x.imageType === 'CutOutFuse'
    )?.url;

    return image;
  }
  getFrontViewImage(id: number) {
    var image = this.siteVerification.images?.filter(
      (x) => x.imageType === 'Frontview'
    )[id]?.url;

    return image;
  }
  onModalFade() {
    this.currentRotation = 0;

    if (this.imgZoomFullContainer) {
      var displayValue = getComputedStyle(this.imgZoomFullContainer).display;

      if (displayValue == 'block') {
        this.imgElement.click();
      }
    }

    this.selectedImage = '';
  }

  onModalOpen() {
    this.renderer.setStyle(document.body, 'overflow', 'auto');
    this.renderer.setStyle(document.body, 'overflow-x', 'hidden');
    this.renderer.setStyle(document.body, 'padding-right', '0');
  }
  openDropdown() {
    this.isDropdownOpened = true;
  }
  onModalAssignFade() {
    this.filterText = this.siteVerification.assignedUser
      ? this.siteVerification.assignedUser
      : '';
  }

  onModalApproveFade() {
    this.isDropdownOpened = false;
  }

  selectFieldAgent(id: number) {
    this.isDropdownOpened = false;
    this.assignedUserId = id;
    this.tempAssignedUserId = id;
    var mobUser = this.mobileUsers.find((x) => x.id == id);
    this.filterText = mobUser!.fullName;
  }
  assignTask(): void {
    if (
      this.mobileUsers.filter((x) => x.fullName == this.filterText.trim())
        .length > 0
    ) {
      this.assignedUserId = this.mobileUsers.filter(
        (x) => x.fullName == this.filterText.trim()
      )[0].id;
      this.tempAssignedUserId = this.assignedUserId;
    } else {
      this.tempAssignedUserId = 0;
    }
    if (this.tempAssignedUserId != 0) {
      this.siteVerificationService
        .assignVerification(parseInt(this.id), this.assignedUserId)
        .subscribe({
          next: (response) => {
            const responseData = response.body;
            if (responseData?.status === 200 || responseData?.status === 'OK') {
              this.closeModal?.nativeElement?.click();
              this.toastr.success('Successfully assigned user');
              window.location.reload();
            } else {
              this.toastr.error(responseData?.message);
            }
          },
          error: (_) => {
            this.toastr.error('Error occured');
          },
        });
    } else {
      this.toastr.warning('Please select valid user.');
    }
  }
  showApproveConfirm(event: Event) {
    event.preventDefault();
    event.stopPropagation();
    if (!this.validateSVForApproval()) return;
    this.showApprove = true;
    this.showReject = false;
    this.showSuspend = false;
  }

  showRejectForm(event: Event) {
    event.preventDefault();
    event.stopPropagation();
    this.showApprove = false;
    this.showReject = true;
    this.showSuspend = false;
  }

  showSuspendConfirm(event: Event) {
    event.preventDefault();
    event.stopPropagation();
    this.showSuspend = true;
    this.showApprove = false;
    this.showReject = false;
  }

  cancelUpdateStatus(event: Event) {
    event.preventDefault();
    event.stopPropagation();
    this.showApprove = false;
    this.showReject = false;
    this.showSuspend = false;
  }

  cancelModal() {
    this.showApprove = false;
    this.showReject = false;
    this.showSuspend = false;
  }

  approve() {
    if (!this.validateSVForApproval()) return;

    this.siteVerificationService
      .approveSiteVerification(parseInt(this.id))
      .subscribe({
        next: (response) => {
          if (response?.status === 200 || response?.status === 'OK') {
            this.toastr.success('Site Verification Approved');
            this.cancelModal();
            window.location.reload();
          } else {
            this.toastr.error(response?.message);
          }
        },
      });
  }

  submitSuspend() {
    let obj = {
      id: parseInt(this.id),
      note: this.suspensionNote,
    };

    this.siteVerificationService
      .suspendSiteVerification(obj)
      .subscribe({
        next: (response) => {
          if (response?.status === 200 || response?.status === 'OK') {
            this.toastr.success('Site Verification Suspended');
            this.cancelModal();
            window.location.reload();
          } else {
            this.toastr.error(response?.message || 'Failed to suspend.');
          }
        },
        error: (_) => {
          this.toastr.error('Error occured.');
        },
      });
  }

  recallSiteVerification() {
    this.showRecallMenu = false;
    this.siteVerificationService
      .recallSiteVerification(parseInt(this.id))
      .subscribe({
        next: (response) => {
          if (response?.status === 200 || response?.status === 'OK') {
            this.toastr.success('Site Verification Recalled');
            window.location.reload();
          } else {
            this.toastr.error(response?.message || 'Failed to recall.');
          }
        },
        error: (_) => {
          this.toastr.error('Error occured.');
        },
      });
  }
  isEmail(search: string): boolean {
    var serchfind: boolean;

    var regexp = new RegExp(
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );

    serchfind = regexp.test(search);
    return serchfind;
  }

  isPhoneNumber(search: string): boolean {
    var serchfind: boolean;

    var regexp = new RegExp(
      /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{3,6}$/im
    );

    serchfind = regexp.test(search);
    return serchfind;
  }

  reject() {
    let obj = {
      id: parseInt(this.id),
      note: this.rejectionNote,
    };

    this.siteVerificationService.rejectSiteVerification(obj).subscribe({
      next: (response) => {
        if (response?.status === 200 || response?.status === 'OK') {
          this.toastr.success('Site Verification Rejected');
          this.cancelModal();
          window.location.reload();
        } else {
          this.toastr.error(response?.message);
        }
      },
    });
  }
  setFieldsVisibility() {
    let notVisibleFields: any = localStorage.getItem('notVisibleFields');

    if (!notVisibleFields) {
      return;
    }
    notVisibleFields = JSON.parse(notVisibleFields);
    this.areLocationImagesVisible = notVisibleFields.find(
      (el: any) => el === 'locationPictures'
    )
      ? false
      : true;
  }
  save() {
    if (!this.isEmail(this.siteVerification.accountKyc?.email ?? '')) {
      this.toastr.error('Invalid Email.');
      return;
    }
    if (!this.isPhoneNumber(this.siteVerification.accountKyc?.phoneNumber ?? '')) {
      this.toastr.error('Invalid Phone Number.');
      return;
    }
    if (this.authService.hasCimDataIntegration) {
      if (!this.svGeographicalRegionId) {
        this.toastr.warning(this.translateService.instant('SITE_VERIFICATION.VALIDATION.BU_REQUIRED'));
        return;
      }
      if (!this.siteVerification.subgeographicalRegionId) {
        this.toastr.warning(this.translateService.instant('SITE_VERIFICATION.VALIDATION.UT_REQUIRED'));
        return;
      }
    } else {
      if (!this.svRegionId) {
        this.toastr.warning(this.translateService.instant('SITE_VERIFICATION.VALIDATION.BU_REQUIRED'));
        return;
      }
      if (!this.svAreaId) {
        this.toastr.warning(this.translateService.instant('SITE_VERIFICATION.VALIDATION.UT_REQUIRED'));
        return;
      }
      this.siteVerification.area.id = this.svAreaId;
    }
    this.siteVerification.isReview = false;

    this.siteVerificationService
      .editSiteVerification(this.siteVerification)
      .subscribe({
        next: (response) => {
          if (response?.status === 200 || response?.status === 'OK') {
            this.toastr.success(
              'Successfully updated Site Verification details.'
            );
            window.location.reload();
          } else {
          }
        },
        error: (_) => {
          this.toastr.error('Error occured.');
        },
      });
    this.editEnabled = false;
  }
  private getSiteVerification(Id: any) {
    this.siteVerificationService.get(Id).subscribe({
      next: (response) => {
        const responseData = response.body;
        if (responseData?.status === 200 || responseData?.status === 'OK') {
          this.siteVerification = responseData.data;
          this.siteVerification.accountKyc.meterNumber = responseData.data.accountKyc?.customerInformation?.meter?.number ?? '';
          this.totalLoad = this.siteVerification.accountKyc?.loadRequirements?.reduce((sum, lr) => sum + (lr.wattage ?? 0), 0);
          this.setClientAndCustomerType();
        } else {
          this.toastr.error(responseData?.message);
        }
      },
      error: (_) => {
        this.toastr.error('Error occured');
      },
    });
  }


  public hideWord(w: any) {
    if (w) {
      if (w.length < 3) return w;
      return w.substring(0, 3) + '*'.repeat(w.length - 3);
    }
  }
  subServieSpaces(value: string | undefined) {
    switch (value) {
      case 'PublicLoad':
        return 'Public Load';

      case 'MeterReplacement':
        return 'Meter Replacement';

      case 'Migration':
        return 'Migration';

      case 'Separation':
        return 'Separation';

      case 'PointLoadTransformer':
        return 'Point Load Transformer';

      case 'DedicatedFeeder':
        return 'Dedicated Feeder';

      default:
        return value;
    }
  }
  openPdf(pdfUrl: string) {
    if (pdfUrl == '') {
      this.toastr.info("No PDF to view.")
      return;
    }
    window.open(pdfUrl, '_blank');
  }

  enterSvEdit() {
    this.svEditEnabled = true;
    this.svRegionId = this.siteVerification.area?.regionId ?? 0;
    this.svAreaId = this.siteVerification.accountKyc?.addressOfLandlord?.areaId ?? 0;
    this.svCardDtFilter = '';
    this.svSvDtFilter = '';
    this.svCardDtDropdownOpen = false;
    this.svSvDtDropdownOpen = false;
    this.svCardSubstationFilter = '';
    this.svSvSubstationFilter = '';
    this.svCardSubstationDropdownOpen = false;
    this.svSvSubstationDropdownOpen = false;
    this.svTariffDropdownOpen = false;
    if (this.authService.hasCimDataIntegration) {
      this.getGeoRegions();
      this.getSubGeoRegions();
      this.getSubstations();
    } else {
      this.loadRegions();
      if (this.siteVerification.area?.regionId) {
        this.loadAreasByRegion(this.siteVerification.area.regionId);
      }
    }
    this.loadFeeders();
    this.loadFeeders33();
    this.loadSvSelectOptions();
  }

  cancelSvEdit() {
    this.svEditEnabled = false;
    this.svCardDtResults = [];
    this.svSvDtResults = [];
    this.svCardDtFilter = '';
    this.svSvDtFilter = '';
    this.svCardDtDropdownOpen = false;
    this.svSvDtDropdownOpen = false;
    this.svCardSubstationResults = [];
    this.svSvSubstationResults = [];
    this.svCardSubstationFilter = '';
    this.svSvSubstationFilter = '';
    this.svCardSubstationDropdownOpen = false;
    this.svSvSubstationDropdownOpen = false;
    this.svTariffDropdownOpen = false;
    this.getSiteVerification(this.id);
  }

  saveSvEdit() {
    if (!this.validateSiteVerification()) {
      return;
    }
    if (!this.authService.hasCimDataIntegration) {
      this.siteVerification.area.id = this.svAreaId;
    }
    this.siteVerification.isReview = true;

    this.uploadPendingImages(() =>
      this.siteVerificationService.editSiteVerification(this.siteVerification).subscribe({
        next: (response) => {
          if (response?.status === 200 || response?.status === 'OK') {
            this.toastr.success('Site Verification updated successfully.');
            this.svEditEnabled = false;
            if (this.siteVerification.remark === 'Approve') {
              this.router.navigate(['/new-service/3']);
            } else {
              window.location.reload();
            }
          } else {
            this.toastr.error(response?.message || 'Failed to save.');
          }
        },
        error: (_) => this.toastr.error('Error occurred.'),
      })
    );
  }

  private uploadPendingImages(onSuccess: () => void): void {
    if (this.pendingImages.length === 0) {
      onSuccess();
      return;
    }

    const uploads = this.pendingImages.map((img) => {
      const formData = new FormData();
      formData.append('entityId', this.siteVerification.id.toString());
      formData.append('image', img.file, img.file.name);
      formData.append('imageType', ImageType[img.imageType as keyof typeof ImageType].toString());
      formData.append('guid', this.siteVerification.guid);
      formData.append('url', img.url);
      formData.append('imageId', img.existsAtSlot ? img.slotIndex.toString() : '-1');
      return this.siteVerificationService.uploadImage(formData);
    });

    forkJoin(uploads).subscribe({
      next: () => {
        this.pendingImages = [];
        onSuccess();
      },
      error: () => this.toastr.error('Image upload failed.'),
    });
  }

  onRemarkChange(value: number) {
    if (value === SiteVerificationRemark.Approve) {
      this.siteVerification.rejectionReason = '';
    }
  }
  validateSVForApproval() {
    if (!this.siteVerification.dt?.name) {
      this.toastr.warning(this.translateService.instant('SITE_VERIFICATION.VALIDATION.DT_AND_FEEDER_REQUIRED'));
      return false;
    }
    if (!this.siteVerification.tariff) {
      this.toastr.warning(this.translateService.instant('SITE_VERIFICATION.VALIDATION.TARIFF_REQUIRED'));
      return false;
    }
    return true;
  }

  validateSiteVerification() {
    if (this.authService.hasCimDataIntegration) {
      if (!this.svGeographicalRegionId) {
        this.toastr.warning(this.translateService.instant('SITE_VERIFICATION.VALIDATION.BU_REQUIRED'));
        return false;
      }
      if (!this.siteVerification.subgeographicalRegionId) {
        this.toastr.warning(this.translateService.instant('SITE_VERIFICATION.VALIDATION.UT_REQUIRED'));
        return false;
      }
    } else {
      if (!this.svRegionId) {
        this.toastr.warning(this.translateService.instant('SITE_VERIFICATION.VALIDATION.BU_REQUIRED'));
        return false;
      }
      if (!this.svAreaId) {
        this.toastr.warning(this.translateService.instant('SITE_VERIFICATION.VALIDATION.UT_REQUIRED'));
        return false;
      }
    }
    if (!this.siteVerification.dt?.name) {
      this.toastr.warning(this.translateService.instant('SITE_VERIFICATION.VALIDATION.DT_REQUIRED'));
      return false;
    }
    if (!this.siteVerification.connectionType) {
      this.toastr.warning(this.translateService.instant('SITE_VERIFICATION.VALIDATION.CONNECTION_TYPE_REQUIRED'));
      return false;
    }
    if (!this.siteVerification.typeOfCable) {
      this.toastr.warning(this.translateService.instant('SITE_VERIFICATION.VALIDATION.TYPE_OF_CABLE_REQUIRED'));
      return false;
    }
    if (!this.siteVerification.connectionPossible) {
      this.toastr.warning(this.translateService.instant('SITE_VERIFICATION.VALIDATION.CONNECTION_POSSIBLE_REQUIRED'));
      return false;
    }
    if (!this.siteVerification.needForPole) {
      this.toastr.warning(this.translateService.instant('SITE_VERIFICATION.VALIDATION.NEED_FOR_POLE_REQUIRED'));
      return false;
    }
    if (this.siteVerification.typeOfConnection == null) {
      this.toastr.warning(this.translateService.instant('SITE_VERIFICATION.VALIDATION.TYPE_OF_CONNECTION_REQUIRED'));
      return false;
    }
    if (this.siteVerification.neighborhood == null) {
      this.toastr.warning(this.translateService.instant('SITE_VERIFICATION.VALIDATION.NEIGHBORHOOD_REQUIRED'));
      return false;
    }
    if (!this.siteVerification.numberOfRooms) {
      this.toastr.warning(this.translateService.instant('SITE_VERIFICATION.VALIDATION.NUMBER_OF_ROOMS_REQUIRED'));
      return false;
    }
    if (!this.siteVerification.sltStatusValue) {
      this.toastr.warning(this.translateService.instant('SITE_VERIFICATION.VALIDATION.SLT_STATUS_REQUIRED'));
      return false;
    }
    if (!this.siteVerification.tariff) {
      this.toastr.warning(this.translateService.instant('SITE_VERIFICATION.VALIDATION.TARIFF_REQUIRED'));
      return false;
    }
    if (!this.siteVerification.meterBrand) {
      this.toastr.warning(this.translateService.instant('SITE_VERIFICATION.VALIDATION.METER_TYPE_REQUIRED'));
      return false;
    }
    if (this.siteVerification.clientType == null) {
      this.toastr.warning(this.translateService.instant('SITE_VERIFICATION.VALIDATION.CLIENT_TYPE_REQUIRED'));
      return false;
    }
    if (!this.siteVerification.latitude || !this.siteVerification.longitude) {
      this.toastr.warning(this.translateService.instant('SITE_VERIFICATION.VALIDATION.GEOLOCATION_REQUIRED'));
      return false;
    }
    if (!this.siteVerification.remark) {
      this.toastr.warning(this.translateService.instant('SITE_VERIFICATION.VALIDATION.REMARK_REQUIRED'));
      return false;
    }
    if (this.siteVerification.remark != 'Approve' && (!this.siteVerification.rejectionReason && !this.siteVerification.suspensionReason)) {
      this.toastr.warning(this.translateService.instant('SITE_VERIFICATION.VALIDATION.REASON_REQUIRED'));
      return false;
    }
    if (!this.getFrontViewImage(0)) {
      this.toastr.warning(this.translateService.instant('SITE_VERIFICATION.VALIDATION.FRONTVIEW_IMAGES_REQUIRED'));
      return false;
    }
    if (this.areLocationImagesVisible) {
      if (!this.getFrontViewImage(1) || !this.getFrontViewImage(2)) {
        this.toastr.warning(this.translateService.instant('SITE_VERIFICATION.VALIDATION.FRONTVIEW_IMAGES_REQUIRED'));
        return false;
      }
      if (!this.getBuildingMountedImage()) {
        this.toastr.warning(this.translateService.instant('SITE_VERIFICATION.VALIDATION.MOUNTED_TAG_REQUIRED'));
        return false;
      }
      if (!this.getCutOutImage()) {
        this.toastr.warning(this.translateService.instant('SITE_VERIFICATION.VALIDATION.CUT_OUT_REQUIRED'));
        return false;
      }
      if (this.siteVerification.accountKyc?.clientTypeString === 'Individual' &&
        !this.siteVerification.accountKyc?.applicantsSignitureUrl && !this.getCardImage()) {
        this.toastr.warning(this.translateService.instant('SITE_VERIFICATION.VALIDATION.CARD_REQUIRED'));
        return false;
      }
    }

    return true;
  }

  private loadRegions() {
    this.regionService.getRegionsForOptions().subscribe({
      next: (data: any) => {
        this.regions = data?.data ?? data ?? [];
      },
    });
  }

  private loadFeeders() {
    this.feeder11Service.getAllForSelect().subscribe({
      next: (response: any) => {
        this.svFeeders = response?.body?.data ?? [];
      },
    });
  }

  private loadFeeders33() {
    this.feeder33Service.getAllForSelect().subscribe({
      next: (response: any) => {
        this.svFeeders33 = response?.body?.data ?? [];
      },
    });
  }

  private loadSvSelectOptions() {
    this.svNeighborhoodOptions = Object.values(Neighborhood)
      .filter((v) => !isNaN(Number(v)))
      .map((key) => ({ key: Number(key), value: Neighborhood[key as number] }));

    this.svClientTypeOptions = Object.values(ClientType)
      .filter((v) => Number(v) !== -1 && !isNaN(Number(v)))
      .map((key) => ({ key: Number(key), value: ClientType[key as number] }));

    this.svTypeOfConnectionOptions = Object.values(TypeOfConnection)
      .filter((v) => Number(v) !== -1 && !isNaN(Number(v)))
      .map((key) => ({ key: Number(key), value: TypeOfConnection[key as number] }));

    this.svRemarks = Object.values(SiteVerificationRemark)
      .filter((v) => isNaN(Number(v)))
      .map((key) => ({ key: key as string, value: key as string }));
    this.customerService.getSltStatusesForOptions().subscribe({
      next: (response: any) => {
        this.svSltOptions = response?.body?.data ?? [];
      },
    });
    this.svTypeOfConnections = Object.values(DTTypeOfConnection)
      .filter((v) => Number(v) !== -1 && !isNaN(Number(v)))
      .map((key) => ({ key: Number(key), value: DTTypeOfConnection[key as number] }));

    this.svTypesOfCable = Object.values(SiteVerificationTypeOfCable)
      .filter((v) => Number(v) !== -1 && !isNaN(Number(v)))
      .map((key) => ({ key: Number(key), value: SiteVerificationTypeOfCable[key as number] }));

    this.svConnectionPossibleoptions = Object.values(SiteVerificationConnectionPossible)
      .filter((v) => Number(v) !== -1 && !isNaN(Number(v)))
      .map((key) => ({ key: Number(key), value: SiteVerificationConnectionPossible[key as number] }));

    this.svNeedForPoleOptions = Object.values(SiteVerificationNeedForPole)
      .filter((v) => Number(v) !== -1 && !isNaN(Number(v)))
      .map((key) => ({ key: Number(key), value: SiteVerificationNeedForPole[key as number] }));

    this.meterService.getMeterTypesForOptions().subscribe({
      next: (response: any) => {
        this.svMeterTypeOptions = response?.body?.data ?? [];
      },
    });

    this.tariffService.getAllForSelect().subscribe({
      next: (response: any) => {
        this.svTariffs = response?.body?.data ?? [];
      },
    });
  }

  openTariffDropdown() {
    this.svTariffFilter = '';
    this.svTariffResults = [...this.svTariffs];
    this.svTariffDropdownOpen = true;
  }

  onTariffFilterChange(value: string) {
    this.svTariffResults = value
      ? this.svTariffs.filter((t: any) => t.name.toLowerCase().includes(value.toLowerCase()))
      : [...this.svTariffs];
  }

  selectTariff(tariff: any) {
    this.siteVerification.tariff = tariff.name;
    this.svTariffDropdownOpen = false;
  }

  private loadAreasByRegion(regionId: number) {
    if (!regionId) return;
    this.areaService.getAreasForOptionsByRegion(regionId).subscribe({
      next: (data: any) => {
        this.areas = data?.data ?? data ?? [];
      },
    });
  }

  onRegionSelected(regionId: number) {
    const region = this.regions.find((r: any) => r.key === regionId);
    if (region) {
      this.siteVerification.area.regionId = region.key;
      this.siteVerification.area.regionName = region.value;
      this.svAreaId = 0;
      this.areas = [];
      this.loadAreasByRegion(region.key);
    }
  }

  onAreaSelected(areaId: number) {
    const area = this.areas.find((a: any) => a.key === areaId);
    if (area) {
      this.siteVerification.area.id = area.key;
      this.siteVerification.area.name = area.value;
    }
  }

  private syncCimRegionSelection() {
    const sgr = this.subGeoRegions.find(
      (x) => x.id === this.siteVerification.subgeographicalRegionId
    );
    const parentId = sgr?.geographicalRegion?.id ?? 0;
    this.svGeographicalRegionId = parentId;
    if (parentId) {
      this.selectableSubGeoRegions = this.subGeoRegions.filter(
        (x) => x.geographicalRegion?.id === parentId
      );
    }
  }

  onGeoRegionSelected(geoRegionId: number) {
    this.selectableSubGeoRegions = this.subGeoRegions.filter(
      (x) => x.geographicalRegion?.id === geoRegionId
    );
    this.siteVerification.subgeographicalRegionId = null;
  }

  onSubGeoRegionSelected(subGeoRegionId: number) {
    const sgr = this.subGeoRegions.find((x) => x.id === subGeoRegionId);
    const parentId = sgr?.geographicalRegion?.id ?? 0;
    if (parentId && parentId !== this.svGeographicalRegionId) {
      this.svGeographicalRegionId = parentId;
      this.selectableSubGeoRegions = this.subGeoRegions.filter(
        (x) => x.geographicalRegion?.id === parentId
      );
    }
  }

  openCardDtDropdown() {
    if (this.svCardDtDropdownOpen) {
      this.svCardDtDropdownOpen = false;
      return;
    }
    this.svCardDtFilter = '';
    this.dtService.getAllByName('').subscribe({
      next: (response: any) => {
        const dts = (response?.body?.data ?? []) as DtSiteVerification[];
        this.svCardDtResults = dts.filter(d => d.areaId === this.svAreaId).slice(0, 10);
        this.svCardDtDropdownOpen = true;
      },
    });
  }

  onCardDtFilterChange(value: string) {
    this.dtService.getAllByName(value).subscribe({
      next: (response: any) => {
        const dts = (response?.body?.data ?? []) as DtSiteVerification[];
        this.svCardDtResults = dts.filter(d => d.areaId === this.svAreaId).slice(0, 10);
      },
    });
  }

  selectCardDt(dt: any) {
    const feeder = dt.feeder11Id
      ? this.svFeeders.find((f: any) => f.id === dt.feeder11Id)
      : this.svFeeders33.find((f: any) => f.id === dt.feeder33Id);
    this.siteVerification.dt = new DtDto({ id: dt.externalId, name: dt.name, number: dt.number, feeder });
    this.svCardDtDropdownOpen = false;
  }

  openSvDtDropdown() {
    if (this.svSvDtDropdownOpen) {
      this.svSvDtDropdownOpen = false;
      return;
    }
    this.svSvDtFilter = '';
    this.dtService.getAllByName('').subscribe({
      next: (response: any) => {
        const dts = (response?.body?.data ?? []) as DtSiteVerification[];
        this.svSvDtResults = dts.filter(d => d.areaId === this.svAreaId).slice(0, 10);
        this.svSvDtDropdownOpen = true;
      },
    });
  }

  onSvDtFilterChange(value: string) {
    this.dtService.getAllByName(value).subscribe({
      next: (response: any) => {
        const dts = (response?.body?.data ?? []) as DtSiteVerification[];
        this.svSvDtResults = dts.filter(d => d.areaId === this.svAreaId).slice(0, 10);
      },
    });
  }

  selectSvDt(dt: any) {
    const feeder = dt.feeder11Id
      ? this.svFeeders.find((f: any) => f.id === dt.feeder11Id)
      : this.svFeeders33.find((f: any) => f.id === dt.feeder33Id);
    this.siteVerification.dt = new DtDto({ id: dt.externalId, name: dt.name, number: dt.number, feeder });
    this.svSvDtDropdownOpen = false;
  }

  openCardSubstationDropdown() {
    if (this.svCardSubstationDropdownOpen) {
      this.svCardSubstationDropdownOpen = false;
      return;
    }
    this.svCardSubstationFilter = '';
    this.svCardSubstationResults = this.getSubstationResults('');
    this.svCardSubstationDropdownOpen = true;
  }

  onCardSubstationFilterChange(value: string) {
    this.svCardSubstationResults = this.getSubstationResults(value);
  }

  selectCardSubstation(substation: any) {
    this.selectSubstationAsDt(substation);
    this.svCardSubstationDropdownOpen = false;
  }

  openSvSubstationDropdown() {
    if (this.svSvSubstationDropdownOpen) {
      this.svSvSubstationDropdownOpen = false;
      return;
    }
    this.svSvSubstationFilter = '';
    this.svSvSubstationResults = this.getSubstationResults('');
    this.svSvSubstationDropdownOpen = true;
  }

  onSvSubstationFilterChange(value: string) {
    this.svSvSubstationResults = this.getSubstationResults(value);
  }

  selectSvSubstation(substation: any) {
    this.selectSubstationAsDt(substation);
    this.svSvSubstationDropdownOpen = false;
  }

  private getSubstationResults(value: string) {
    const filter = value.toLowerCase();
    return this.substations
      .filter((s: any) => (s.name ?? '').toLowerCase().includes(filter))
      .slice(0, 10);
  }

  private selectSubstationAsDt(substation: any) {
    const incomingLine = (substation.incomingACLines ?? [])[0];
    this.siteVerification.substationId = substation.id;
    this.siteVerification.dt = new DtDto({
      name: substation.name,
      number: substation.number,
      feeder: incomingLine ? { name: incomingLine.name, number: incomingLine.number } : null,
    });
  }

  openSvGeoModal() {
    const hasSaved = this.siteVerification.latitude != null && this.siteVerification.longitude != null;
    this.svHasSavedGeoLocation = hasSaved;

    var latitude = 5.74644;
    var longitude = 0.007479;

    const mapConfig = localStorage.getItem('mapConfiguration');
    if (mapConfig) {
      const config = JSON.parse(mapConfig) as MapConfiguration;
      if (config) {
        latitude = config.latitude!;
        longitude = config.longitude!;
      }
    }

    const lat = this.siteVerification.latitude || latitude;
    const lng = this.siteVerification.longitude || longitude;
    this.svMarkerPosition = { lat, lng };
    this.svMapCenter = { lat, lng };
    this.svPendingLatitude = lat;
    this.svPendingLongitude = lng;

    if (hasSaved) {
      this.svIsMapEditMode = false;
      this.svOriginalLatitude = lat;
      this.svOriginalLongitude = lng;
      this.resolveAddressFromCoordinates({ lat, lng });
    } else {
      this.svIsMapEditMode = true;
    }

    this.updateSvMarkerOptions();
    this.svShouldBlinkMarkerWhenMapReady = !hasSaved;
    this.svGeoModalVisible = true;
  }

  enterSvMapEditMode() {
    this.svIsMapEditMode = true;
    this.updateSvMarkerOptions();
    this.brieflySvBlinkMarker();
    window.setTimeout(() => this.initSvPlacesAutocomplete());
  }

  cancelSvMapSelection() {
    if (this.svHasSavedGeoLocation) {
      this.svIsMapEditMode = false;
      this.updateSvMarkerOptions();
      this.destroySvPlacesAutocomplete();
      this.svPendingLatitude = this.svOriginalLatitude!;
      this.svPendingLongitude = this.svOriginalLongitude!;
      this.svMarkerPosition = { lat: this.svPendingLatitude, lng: this.svPendingLongitude };
      this.svMapCenter = { ...this.svMarkerPosition };
      return;
    }
    this.closeSvGeoModal();
  }

  closeSvGeoModal() {
    this.destroySvPlacesAutocomplete();
    this.svGeoModalVisible = false;
    this.svHasSavedGeoLocation = false;
    this.svIsMapEditMode = false;
    this.updateSvMarkerOptions();
    this.svOriginalLatitude = null;
    this.svOriginalLongitude = null;
    this.svPendingAddress = '';
    this.svMapSearchValue = '';
  }

  onSvMarkerDragStart() {
    this.stopSvMarkerAnimation();
  }

  onSvMarkerDragEnd(event: google.maps.MapMouseEvent) {
    if (!event.latLng) return;
    this.svPendingLatitude = event.latLng.lat();
    this.svPendingLongitude = event.latLng.lng();
    this.svMarkerPosition = { lat: this.svPendingLatitude, lng: this.svPendingLongitude };
    this.resolveAddressFromCoordinates(this.svMarkerPosition);
    this.brieflySvBlinkMarker();
  }

  saveSvGeoLocation() {
    this.siteVerification.latitude = this.svPendingLatitude;
    this.siteVerification.longitude = this.svPendingLongitude;
    this.closeSvGeoModal();
  }

  onSvMapInitialized() {
    window.setTimeout(() => {
      this.refreshSvGeoMap();
      if (this.svShouldBlinkMarkerWhenMapReady) {
        this.svShouldBlinkMarkerWhenMapReady = false;
        this.brieflySvBlinkMarker();
      }
      if (this.svIsMapEditMode) {
        this.initSvPlacesAutocomplete();
      }
    });
  }

  private initSvPlacesAutocomplete() {
    const map = this.svGeoMap?.googleMap;
    if (!map) return;
    this.destroySvPlacesAutocomplete();

    const input = document.createElement('input');
    input.type = 'text';
    input.className = 'sv-geo-map-control-input';
    input.value = this.svPendingAddress;
    input.placeholder = this.translateService.instant('SITE_VERIFICATION.SEARCH_ADDRESS');
    input.autocomplete = 'off';
    this.svSearchInputEl = input;

    map.controls[google.maps.ControlPosition.TOP_CENTER].push(input);

    this.svFullscreenHandler = () => {
      if (document.fullscreenElement) {
        this.onSvEnterFullscreen();
      } else {
        this.onSvExitFullscreen();
      }
    };
    document.addEventListener('fullscreenchange', this.svFullscreenHandler);

    this.svPlacesAutocomplete = new google.maps.places.Autocomplete(input, {
      fields: ['geometry', 'formatted_address'],
    });
    this.svPlacesAutocomplete.addListener('place_changed', () => {
      this.ngZone.run(() => {
        const place = this.svPlacesAutocomplete!.getPlace();
        if (!place.geometry?.location) return;
        const lat = place.geometry.location.lat();
        const lng = place.geometry.location.lng();
        this.svPendingLatitude = lat;
        this.svPendingLongitude = lng;
        this.svMarkerPosition = { lat, lng };
        this.svMapCenter = { lat, lng };
        this.svMapZoom = 17;
        this.svPendingAddress = place.formatted_address ?? '';
        if (this.svSearchInputEl) {
          this.svSearchInputEl.value = this.svPendingAddress;
        }
        this.brieflySvBlinkMarker();
        window.setTimeout(() => this.refreshSvGeoMap());
      });
    });
  }

  private onSvEnterFullscreen() {
    const existing = document.querySelector('.pac-container') as HTMLElement | null;
    if (existing) this.moveSvPacToFullscreen(existing);

    this.svBodyPacObserver = new MutationObserver(() => {
      const pac = document.querySelector('.pac-container') as HTMLElement | null;
      if (pac && document.fullscreenElement && pac.parentElement !== document.fullscreenElement) {
        this.moveSvPacToFullscreen(pac);
      }
    });
    this.svBodyPacObserver.observe(document.body, { childList: true });
  }

  private moveSvPacToFullscreen(pac: HTMLElement) {
    if (!document.fullscreenElement) return;
    document.fullscreenElement.appendChild(pac);
    this.svPacObserver?.disconnect();
    this.svPacObserver = new MutationObserver(() => {
      if (!document.fullscreenElement || !this.svSearchInputEl) return;
      this.svPacObserver!.disconnect();
      const inputRect = this.svSearchInputEl.getBoundingClientRect();
      const fsRect = document.fullscreenElement.getBoundingClientRect();
      pac.style.top = `${inputRect.bottom - fsRect.top}px`;
      pac.style.left = `${inputRect.left - fsRect.left}px`;
      pac.style.width = `${inputRect.width}px`;
      this.svPacObserver!.observe(pac, { attributes: true, attributeFilter: ['style'] });
    });
    this.svPacObserver.observe(pac, { attributes: true, attributeFilter: ['style'] });
  }

  private onSvExitFullscreen() {
    this.svBodyPacObserver?.disconnect();
    this.svBodyPacObserver = undefined;
    this.svPacObserver?.disconnect();
    this.svPacObserver = undefined;
    const pac = document.querySelector('.pac-container') as HTMLElement | null;
    if (pac) {
      document.body.appendChild(pac);
      pac.style.removeProperty('top');
      pac.style.removeProperty('left');
      pac.style.removeProperty('width');
    }
  }

  private destroySvPlacesAutocomplete() {
    if (this.svPlacesAutocomplete) {
      google.maps.event.clearInstanceListeners(this.svPlacesAutocomplete);
      this.svPlacesAutocomplete = undefined;
    }
    this.onSvExitFullscreen();
    if (this.svFullscreenHandler) {
      document.removeEventListener('fullscreenchange', this.svFullscreenHandler);
      this.svFullscreenHandler = undefined;
    }
    const map = this.svGeoMap?.googleMap;
    if (map && this.svSearchInputEl) {
      const controls = map.controls[google.maps.ControlPosition.TOP_CENTER];
      for (let i = 0; i < controls.getLength(); i++) {
        if (controls.getAt(i) === this.svSearchInputEl) {
          controls.removeAt(i);
          break;
        }
      }
    }
    this.svSearchInputEl = null;
  }

  private updateSvMarkerOptions() {
    this.svMarkerOptions = {
      ...this.svMarkerOptions,
      draggable: this.svIsMapEditMode,
    };
  }

  private brieflySvBlinkMarker() {
    this.stopSvMarkerAnimation();
    let isVisible = true;
    let ticks = 0;
    this.svMarkerBlinkIntervalId = window.setInterval(() => {
      isVisible = !isVisible;
      ticks++;
      this.svMarkerOptions = {
        ...this.svMarkerOptions,
        opacity: isVisible ? 1 : 0.35,
      };
      if (ticks >= 10) {
        this.stopSvMarkerAnimation();
      }
    }, 180);
  }

  private stopSvMarkerAnimation() {
    if (this.svMarkerBlinkIntervalId) {
      window.clearInterval(this.svMarkerBlinkIntervalId);
      this.svMarkerBlinkIntervalId = undefined;
    }
    this.svMarkerOptions = {
      ...this.svMarkerOptions,
      animation: null,
      opacity: 1,
    };
  }

  private refreshSvGeoMap() {
    const map = this.svGeoMap?.googleMap;
    if (!map) return;
    google.maps.event.trigger(map, 'resize');
    map.setCenter(this.svMapCenter);
  }

  private resolveAddressFromCoordinates(position: google.maps.LatLngLiteral) {
    const geocoder = new google.maps.Geocoder();
    geocoder.geocode({ location: position }, (results, status) => {
      this.ngZone.run(() => {
        this.svPendingAddress = status === 'OK' && results?.length
          ? results[0].formatted_address
          : '';
        if (this.svSearchInputEl) {
          this.svSearchInputEl.value = this.svPendingAddress;
        }
      });
    });
  }

  onSvImageSelected(event: Event, imageType: string, slotIndex: number = 0) {
    const file = (event.target as HTMLInputElement).files?.[0];
    if (!file) return;
    this.blobStorageService.setContainer(ContainerNames.KYC);
    this.blobStorageService.uploadFile(
      file,
      file.name,
      (url: string) => {
        const sameType = this.siteVerification.images.filter((x) => x.imageType === imageType);
        const existsAtSlot = slotIndex < sameType.length;

        if (existsAtSlot) {
          let count = 0;
          for (const img of this.siteVerification.images) {
            if (img.imageType === imageType) {
              if (count === slotIndex) { img.url = url; break; }
              count++;
            }
          }
        } else {
          this.siteVerification.images.push({ imageType, url });
        }

        this.pendingImages.push({ imageType, slotIndex, url, file, existsAtSlot });
        this.toastr.success('Image selected.');
      },
      (_: any) => this.toastr.error('Image upload failed.'),
    );
  }
}
